(function () {

  /* ================================
     Helpers
  ================================= */

  function toFloat(v, fallback) {
    if (v == null) return fallback;
    var n = parseFloat(String(v).trim());
    return isFinite(n) ? n : fallback;
  }

  function toInt(v, fallback) {
    if (v == null) return fallback;
    var n = parseInt(String(v).trim(), 10);
    return isFinite(n) ? n : fallback;
  }

  function formatMoneyCents(cents, moneyFormat) {
    cents = toInt(cents, 0);
    var dollars = cents / 100;
    var amount = dollars.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var fmt = moneyFormat ? String(moneyFormat) : "${{amount}}";
    if (fmt.indexOf("{{amount}}") !== -1) return fmt.replace("{{amount}}", amount);
    return "$" + amount;
  }

  function parseDollarMatches(txt) {
    if (!txt) return [];
    return String(txt).match(/\$[0-9]+(?:\.[0-9]{2})?/g) || [];
  }

  function dollarsToCents(dollarToken) {
    var num = parseFloat(String(dollarToken).replace("$", ""));
    if (!isFinite(num) || num <= 0) return null;
    return Math.round(num * 100);
  }

  function getText(el) {
    if (!el) return "";
    // innerText catches text that can be "visually" present even when textContent is weird
    return (el.innerText || el.textContent || "").trim();
  }

  /* ================================
     Recharge Purchase Option Detection
     Key idea: Find radios whose LABEL text contains a $ price.
     This avoids grabbing gallery radios.
  ================================= */

  function findPurchaseOptionRadios() {
    var radios = Array.prototype.slice.call(document.querySelectorAll("input[type='radio']"));
    var out = [];

    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];

      // Find an associated label
      var label = null;

      // 1) wrapping label
      if (r.closest) label = r.closest("label");

      // 2) <label for="...">
      if (!label && r.id) {
        label = document.querySelector("label[for='" + CSS.escape(r.id) + "']");
      }

      // 3) nearby sibling label-ish container
      if (!label && r.parentElement) {
        // common pattern: input + span/div text
        label = r.parentElement;
      }

      var txt = getText(label);
      var dollars = parseDollarMatches(txt);

      // Only keep radios that clearly have a price in the row text
      if (dollars && dollars.length) {
        out.push({ radio: r, labelEl: label, text: txt, dollars: dollars });
      }
    }

    return out;
  }

  function getSelectedPurchasePriceCents() {
    var candidates = findPurchaseOptionRadios();
    if (!candidates.length) return null;

    // Prefer the checked one among candidates
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].radio && candidates[i].radio.checked) {
        var d = candidates[i].dollars[candidates[i].dollars.length - 1];
        return dollarsToCents(d);
      }
    }

    // If none appear checked (some widgets manage state differently), try aria/active class:
    // pick the first candidate whose label/container looks "selected"
    for (var j = 0; j < candidates.length; j++) {
      var el = candidates[j].labelEl;
      if (!el) continue;
      var cls = (el.className || "").toString();
      var aria = el.getAttribute ? (el.getAttribute("aria-checked") || "") : "";
      if (cls.match(/active|selected|checked/i) || aria === "true") {
        var d2 = candidates[j].dollars[candidates[j].dollars.length - 1];
        return dollarsToCents(d2);
      }
    }

    return null;
  }

  // Debug helper so you can verify in Console
  window.NOBL_GET_WIDGET_PRICE = function () {
    return getSelectedPurchasePriceCents();
  };
  window.NOBL_LIST_PURCHASE_RADIOS = function () {
    return findPurchaseOptionRadios().map(function (x) {
      return {
        checked: !!x.radio.checked,
        name: x.radio.name,
        id: x.radio.id,
        dollars: x.dollars,
        text: x.text.slice(0, 140)
      };
    });
  };

  /* ================================
     Price resolver for calculator
  ================================= */

  function getPriceCents(root) {
    var base = toInt(root.getAttribute("data-variant-price"), 0);

    // Prefer Recharge widget selection if available
    var widget = getSelectedPurchasePriceCents();
    if (widget && widget > 0) return widget;

    return base;
  }

  /* ================================
     Feeding math
  ================================= */

  function getActivityMultiplier(root) {
    var checked = root.querySelector('input[name="activity"]:checked');
    var val = checked ? checked.value : "normal";
    if (val === "low") return 0.9;
    if (val === "high") return 1.2;
    return 1.0;
  }

  function estimateKcalPerDay(weightLbs, activityMultiplier) {
    var kg = weightLbs / 2.2;
    var rer = 54 * Math.pow(kg, 0.70);
    return rer * activityMultiplier;
  }

  /* ================================
     Init / Boot
  ================================= */

  function initCalc(root) {
    if (root.__noblCalcBound) return;
    root.__noblCalcBound = true;

    var weightInput = root.querySelector("#noblWeight");
    var weightValue = root.querySelector("#noblWeightValue");
    var gramsOut = root.querySelector("#noblGrams");
    var costOut = root.querySelector("#noblCost");
    var daysOut = root.querySelector("#noblDays");
    var bagOut = root.querySelector("#noblBag");
    var modeOut = root.querySelector("#noblMode");

    if (!weightInput || !weightValue || !gramsOut || !costOut || !daysOut || !bagOut || !modeOut) return;

    function recalc() {
      var kcalPerGram = toFloat(root.getAttribute("data-kcal-per-gram"), 5.310);
      var bagGrams = toFloat(root.getAttribute("data-bag-grams"), 992);
      var moneyFormat = root.getAttribute("data-money-format") || "${{amount}}";

      var weight = toFloat(weightInput.value, 25);
      var activityMultiplier = getActivityMultiplier(root);

      var kcalDay = estimateKcalPerDay(weight, activityMultiplier);
      var gramsDay = kcalPerGram > 0 ? (kcalDay / kcalPerGram) : 0;
      var days = gramsDay > 0 ? (bagGrams / gramsDay) : 0;

      var basePrice = toInt(root.getAttribute("data-variant-price"), 0);
      var priceCents = getPriceCents(root);

      modeOut.textContent = (priceCents && basePrice && priceCents !== basePrice) ? "Subscription" : "One-time purchase";

      weightValue.textContent = String(Math.round(weight));
      gramsOut.textContent = gramsDay > 0 ? String(Math.round(gramsDay)) : "—";
      daysOut.textContent = days > 0 ? String(Math.round(days)) : "—";

      if (days > 0 && priceCents > 0) {
        var dailyCostCents = Math.round(priceCents / days);
        costOut.textContent = formatMoneyCents(dailyCostCents, moneyFormat);
      } else {
        costOut.textContent = "—";
      }
    }

    // Weight + activity
    weightInput.addEventListener("input", recalc);
    var radios = root.querySelectorAll('input[name="activity"]');
    for (var i = 0; i < radios.length; i++) radios[i].addEventListener("change", recalc);

    // Variant changes
    var variantSelect = document.querySelector('product-form select[name="id"]') || document.querySelector('select[name="id"]');
    if (variantSelect) variantSelect.addEventListener("change", function () {
      setTimeout(recalc, 0);
      setTimeout(recalc, 120);
    });

    // Purchase option changes: listen for ANY radio changes, but we only read radios that have $ in their label text.
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (!t) return;
      if (t.type === "radio") {
        setTimeout(recalc, 0);
        setTimeout(recalc, 120);
      }
    }, true);

    document.addEventListener("click", function () {
      setTimeout(recalc, 0);
      setTimeout(recalc, 140);
    }, true);

    // Initial + delayed
    recalc();
    setTimeout(recalc, 250);
    setTimeout(recalc, 750);
    setTimeout(recalc, 1500);
  }

  function boot() {
    var roots = document.querySelectorAll(".noblCalc");
    for (var i = 0; i < roots.length; i++) initCalc(roots[i]);
  }

  window.NOBL_CALC_BOOT = boot;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);

})();
